module.exports = __webpack_public_path__ + "img/ic_24_social_whatsapp.ebae2ce8.svg";